import Paragraph from "@pages/Article/components/StoryElements/Paragraph";
import { SanitizedFeedSectionArticle } from "@typings/Cue";
import { isEmpty } from "lodash-es";

type WinnersParagraphComponentProps = {
  /** Article used to get the elements to display paragraph */
  articles: SanitizedFeedSectionArticle[];
  /** Selected year to display the title for winners page */
  selectedYear: string;
};
/**
 * Component to render paragraphs for winners page
 */
const WinnersParagraphComponent = ({
  articles,
  selectedYear,
}: WinnersParagraphComponentProps): React.ReactElement => {
  const selectedYearData = articles.find(
    (article) => article.title === selectedYear
  );
  const articleElements = selectedYearData?.elements || [];

  if (isEmpty(articleElements)) return <></>;

  return (
    <div className="py-6" data-testid="winners-paragraph-component">
      {articleElements.map((element, index) => {
        const hasValue = element.fields.some((f) => f.value);

        if (!hasValue && element.fields.length > 0) {
          return <div key={index} className="mb-6" />;
        }

        return (
          <Paragraph
            key={index}
            element={element}
            className="mb-0 text-gray-850"
          />
        );
      })}
    </div>
  );
};

export default WinnersParagraphComponent;
